import { useTranslation } from "react-i18next";
import ActionButton from "./ActionButton"
import FindInPageIcon from '@mui/icons-material/FindInPage';
import { useDispatch } from "react-redux";
import { setOpenHistoryParams } from "@/features/modals/modalsSlice";

const ActionButtonHistory = ({ channelId }) => {
  const {t} = useTranslation();
  const dispatch = useDispatch()
  return (
    <ActionButton
      color="info"
      startIcon={<FindInPageIcon/>}
      onClick={() => dispatch(setOpenHistoryParams({ channelId }))}
    >
      { t('trigger_history') }
    </ActionButton>
  )
}

export default ActionButtonHistory;